export{KibAccordionNew}from"./kib-accordion-new";export{KibAccordionNewItem}from"./kib-accordion-new-item/kib-accordion-new-item";export*from"./typings";